import decodeJwt from 'jwt-decode'
import { fromUnixTime, isBefore } from 'date-fns'

export const TOKEN = 'token'
export const REFRESH_TOKEN = 'refreshtoken'

export const setTokens = (token: string, refreshToken: string) => {
  localStorage.setItem(TOKEN, token)
  localStorage.setItem('refreshtoken', refreshToken)
  if (token) {
    document.cookie = `token=${token}; path=/; max-age=31536000; SameSite=Lax`
  } else {
    document.cookie = 'token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }
}

export const getToken = () => localStorage.getItem(TOKEN)

interface decodeJwtResult {
  exp: number
}

export const isLoggedIn = () => {
  // const token = getSecureStorage('dca-t')
  const refreshToken = localStorage.getItem(TOKEN)
  // if (!token || !refreshToken)
  if (!refreshToken) {
    return false
  }

  // const decodedToken = decodeJwt(token) as any
  const decodedRefreshToken = decodeJwt<decodeJwtResult>(refreshToken)

  // const tokenTime = moment(decodedToken.exp).utc()

  if (isBefore(fromUnixTime(decodedRefreshToken.exp), new Date())) return false

  return true
}
